import { useMutation } from '@tanstack/react-query';
import { useGlobalAppBackdropStore } from 'components/full-page-blocker/GlobalAppBackdrop';
import { configureChatTabThunk } from 'features/aiWriter/store/actions/tabs/thunks/configureChatTabThunk';
import { initializeTabThunk } from 'features/aiWriter/store/actions/tabs/thunks/initializeTabThunk';
import { unnamed } from 'features/aiWriter/utils/unnamed';
import useGetModelAudiences from 'features/audiences/hooks/useGetModelAudiences';
import { fetchDefaultOutputTypeByLanguageCountry } from 'features/textGenerator/utils/useGetPromptsOthers';
import { useAppDispatch } from 'store/hooks';
import { assertNonNullable } from 'utils/typescript/nonNullable';

export const useCreateAiWriterProjectMutation = () => {
  const getModelAudiences = useGetModelAudiences();
  const dispatch = useAppDispatch();
  const showGlobalBackdrop = useGlobalAppBackdropStore(state => state.show);
  const hideGlobalBackdrop = useGlobalAppBackdropStore(state => state.hide);

  return useMutation({
    mutationFn: async (params: { embeddingModelId: string; brandVoiceId: string }) => {
      const { embeddingModelId, brandVoiceId } = params;
      const audience = getModelAudiences(embeddingModelId)[0];
      assertNonNullable(audience.language, 'Audience language falsy');
      assertNonNullable(audience.country, 'Audience country falsy');

      const outputType = await fetchDefaultOutputTypeByLanguageCountry(
        audience.language,
        audience.country
      );

      await dispatch(
        initializeTabThunk(
          {
            embeddingModelId: embeddingModelId,
            audienceId: audience.id,
            name: unnamed,
            isNewDocument: true,
            outputType,
            brief: '',
            keywords: '',
            keywords2: '',
            tonality: [],
            brandVoiceId
          },
          configureChatTabThunk,
          { shouldCollapseSidebar: false }
        )
      );
    },
    onMutate: () => {
      showGlobalBackdrop();
    },
    onSuccess: () => {
      hideGlobalBackdrop();
    },
    onError: () => {
      hideGlobalBackdrop();
    }
  });
};
